<div id="cost-report-modal" class="emp-cost innerpad">
    <div class="popoup-hearder innerpadLeft">
        <h2 class="m-b-5" mat-dialog-title>Costo del empleado</h2>
    </div>
    <form [formGroup]="costReportForm" (ngSubmit)="onSubmit()" >
       
    <div class="popoup-content">
        <div class="block-looper-wrapper">
            <div class="block-looper">
                <div class="each">
                    <div class="three-view">
                        <label class="container-radio">Coste del Trabajador
                            <input (change)="reportTypeClick($event)" [(ngModel)]="defaultReportType" formControlName="DefaultReport" value="Excel"  type="radio" checked="true" name="DefaultReport">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div class="each">
                    <div class="three-view">
                        <label  class="container-radio">Infome de Costes e Indemnización
                            <input (change)="reportTypeClick($event)" [(ngModel)]="defaultReportType" formControlName="DefaultReport" value="Word" type="radio"  name="DefaultReport">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="block-looper">
                <div class="each chbox">
                    <div class="field-set">
                        <mat-checkbox [(ngModel)]="defaultCheckBox"  (change)="enfermedadClick($event)"  formControlName="Enfermedad" checked="checked" class="example-margin">Enfermedad
                        </mat-checkbox>
                    </div>
                </div>
                <div class="each chbox">
                    <div class="field-set">
                        <mat-checkbox (change)="accidenteClick($event)" formControlName="AccidenteLaboral"class="example-margin">Accidente laboral
                        </mat-checkbox>
                    </div>
                </div>
                <div class="each chbox">
                    <div class="field-set">
                        <mat-checkbox formControlName="PermisoRetribuido" class="example-margin">Permiso retribuido
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <!-- <pre>{{costReportForm.value | json}}</pre> -->
            <div class="block-looper">
                <div class="half half-left wauto" *ngIf="datePeridIsShow">
                    <h3>Periodo</h3>
                    <div class="half date">
                        <mat-form-field appearance="fill">
                            <input formControlName="DateFrom" matInput [matDatepicker]="picker2">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <mat-error
                            *ngIf="costReportForm.get('DateFrom').invalid && costReportForm.get('DateFrom').touched">
                            <span *ngIf="costReportForm.get('DateFrom').hasError"> La fecha es obligatoria</span>
                        </mat-error>   
                    </div>
                    <div class="half date">
                        <mat-form-field appearance="fill">
                            <input formControlName="DateTo" matInput [matDatepicker]="picker3">
                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                        </mat-form-field>
                        <mat-error
                            *ngIf="costReportForm.get('DateTo').invalid && costReportForm.get('DateTo').touched">
                            <span *ngIf="costReportForm.get('DateTo').hasError"> La fecha es obligatoria</span>
                        </mat-error>  
                    </div>
                    <!-- <div class="period-pick">
                        <button mat-icon-button [matMenuTriggerFor]="sendpop">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu #sendpop="matMenu" class="w-240">
                            <button mat-menu-item>
                                <span>1/5/2021 - 15/5/2021</span>
                            </button>
                            <button mat-menu-item>
                                <span>18/5/2021 - 30/5/2021</span>
                            </button>
                            <button mat-menu-item>
                                <span>1/6/2021 - 15/6/2021</span>
                            </button>
                            <button mat-menu-item>
                                <span>16/6/2021 - 20/6/2021</span>
                            </button>
                            <button mat-menu-item>
                                <span>20/6/2021 - 30/6/2021</span>
                            </button>
                        </mat-menu>
                    </div> -->
                </div>
                <div *ngIf="enfermedadIsChecked" class="half half-right">
                    <label>Convenio</label>
                    <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="selectedValue($event)" formControlName="Convenio">
                            <mat-option *ngFor="let options of conveniosDataSource" [value]="options.convenioId">{{options.nombre}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error
                            *ngIf="costReportForm.get('Convenio').invalid && costReportForm.get('Convenio').touched">
                            <span *ngIf="costReportForm.get('Convenio').hasError"> La Convenio es obligatoria</span>
                   </mat-error>
                </div>
            </div>
            <div class="block-looper">
                <div class="half" *ngIf="accidenteIsChecked">
                    <label>Contingencias Profesionales</label>
                    <mat-form-field class="example-full-width" appearance="fill">
                        <input formControlName="ContProfesionales" matInput type="number">
                    </mat-form-field>
                    <mat-error
                            *ngIf="costReportForm.get('ContProfesionales').invalid && costReportForm.get('ContProfesionales').touched">
                            <span *ngIf="costReportForm.get('ContProfesionales').hasError"> La Contingencias Profesionales es obligatoria</span>
                   </mat-error>
                </div>
                <div class="w120">
                    <label>Salario bruto</label>
                    <mat-form-field class="example-full-width" appearance="fill">
                        <input formControlName="SalarioBruto" matInput type="number">
                        <span matSuffix>€</span>
                    </mat-form-field>
                    <mat-error
                            *ngIf="costReportForm.get('SalarioBruto').invalid && costReportForm.get('SalarioBruto').touched">
                            <span *ngIf="costReportForm.get('SalarioBruto').hasError"> La Salario bruto es obligatoria</span>
                   </mat-error>
                </div>

            </div>
        </div>
    </div>
   
    
    <div class="popoup-footer innerpad">
        <button type="submit" mat-button color="primary" class="keep"><span class="mat-button-wrapper">Aceptar</span></button>
        <button type="button" mat-button color="accent" class="cancel" (click)="close()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
    </form>
    
</div>